(function(){
  'use strict';

  function pushEvent(eventName,card){
    try{
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({
        event:eventName,
        product_id:card.getAttribute('data-product-id')||null,
        product_name:card.getAttribute('data-product-title')||null,
        value:Number(card.getAttribute('data-product-value'))||null,
        currency:'USD',
        page_location:window.location.href
      });
    }catch(e){}
  }

  function bindTracking(card){
    if(card.getAttribute('data-qsp-tracking-bound')==='true')return;
    card.setAttribute('data-qsp-tracking-bound','true');

    var details=card.querySelector('[data-qsp-shipping-details]');
    if(details){
      details.addEventListener('toggle',function(){
        if(details.open&&details.getAttribute('data-qsp-open-tracked')!=='true'){
          details.setAttribute('data-qsp-open-tracked','true');
          pushEvent('shipping_details_opened',card);
        }
      });
    }

    card.addEventListener('click',function(event){
      var link=event.target.closest('[data-qsp-event="agency_locator_clicked"]');
      if(link)pushEvent('agency_locator_clicked',card);
    });

    if('IntersectionObserver'in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            pushEvent('shipping_summary_viewed',card);
            observer.disconnect();
          }
        });
      },{threshold:.35});
      observer.observe(card);
    }else{
      pushEvent('shipping_summary_viewed',card);
    }
  }

  function mountCard(card){
    if(!card||card.getAttribute('data-qsp-mounted')==='true')return;

    var mainForm=document.querySelector('.product-info .js-product-form-main');
    var buyBlock=mainForm?mainForm.closest('.product-info__block'):null;
    if(!buyBlock)return;

    var sectionId=card.getAttribute('data-qsp-section-id');
    var host=document.getElementById('shopify-section-'+sectionId)||card.parentElement;
    buyBlock.insertAdjacentElement('afterend',host);
    card.hidden=false;
    card.setAttribute('data-qsp-mounted','true');

    var legacy=document.querySelector('.product-info .qsp-envios');
    var legacyBlock=legacy?legacy.closest('.product-info__block'):null;
    if(legacyBlock&&!legacyBlock.contains(card))legacyBlock.remove();

    bindTracking(card);
  }

  function init(){
    document.querySelectorAll('[data-qsp-shipping-summary]').forEach(mountCard);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }

  document.addEventListener('shopify:section:load',init);
})();